import {
  ChangeDetectionStrategy,
  Component,
  input,
  computed,
  output,
  signal,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { AvatarComponent } from '../../../../../../../ui-components/lib/avatar/avatar.component';
import { BadgeComponent } from '../../../../../../../ui-components/lib/badge/badge.component';
import { LoaderComponent } from '../../../../../../../ui-components/lib/loader/loader.component';
import { ClickOutSideDirective } from '../../../../../../../ui-components/directives/clickOutSide.directive';
import { CloseIconComponent } from '@kuiper/icons';
import { TranslocoPipe } from '@jsverse/transloco';
import { EmojiLookup, UserReaction } from '../../request-discussion.model';
import { Meta } from '../../../../../../../core/common/models/api-response.model';

@Component({
  selector: 'lib-comment-reaction-list',
  imports: [
    CloseIconComponent,
    AvatarComponent,
    BadgeComponent,
    LoaderComponent,
    TranslocoPipe,
    ClickOutSideDirective,
  ],
  templateUrl: './comment-reaction-list.component.html',
  styleUrl: './comment-reaction-list.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class CommentReactionListComponent implements OnInit, OnDestroy {
  commentReactions = input<UserReaction[]>([]);
  meta = input<Meta>({
    current_page: 1,
    from: 0,
    last_page: 0,
    links: [],
    path: '',
    per_page: 0,
    to: 0,
    total: 0,
  });
  showAllReactions = input<boolean>(false);
  reactionCount = input<number>(0);
  allCommentReactions = input<UserReaction[]>([]);
  emojisLookup = input<EmojiLookup[]>([]);
  isReactionsLoading = input<boolean>(false);

  toggleUserReactions = output<boolean>();
  toggleEmojiTab = output<string>();

  emojis = computed(() => {
    return new Set(
      this.commentReactions().map(reaction => reaction.emoji.emoji)
    );
  });
  emojiActiveTab = signal<string>('');

  ngOnInit() {
    document.addEventListener('keydown', event => this.handleEscapeKey(event));
  }

  handleEscapeKey(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.showAllReactions()) {
      this.toggleUserReactions.emit(false);
    }
  }

  ngOnDestroy() {
    document.removeEventListener('keydown', () => this.handleEscapeKey);
  }
}
